module.exports = __webpack_public_path__ + "img/tp7.852d6be7.png";